export default function Children({ children = null, ...props }) {
  return typeof children === 'function' ? children(props) : children
}
